export default __webpack_public_path__ + "c97cdddbcb4a262d87dfc28dd2cec099.svg";